module.exports = __webpack_public_path__ + "static/media/收藏夹.d091e548.png";